import { combineReducers } from "@reduxjs/toolkit";

import appNoticeReducer from "./appNoticeSlice";
import availabilitiesReducer from "./availabilitiesSlice";
import countryReducer from "./countrySlice";
import doctorLicencePlansReducer from "./doctorLicencePlansSlice";
import errorReducer from "./errorSlice";
import faqReducer from "./faqSlice";
import notificationReducer from "./notificationSlice";
import paymentReducer from "./paymentSlice";
import sessionReducer from "./sessionSlice";
import specialtiesReducer from "./specialtiesSlice";

export const rootReducer = combineReducers({
  session: sessionReducer,
  country: countryReducer,
  availabilities: availabilitiesReducer,
  error: errorReducer,
  specialties: specialtiesReducer,
  notifications: notificationReducer,
  faqs: faqReducer,
  appNotice: appNoticeReducer,
  doctorLicencePlans: doctorLicencePlansReducer,
  payment: paymentReducer,
});
